define.alias("shared/components/shared/ui/social-profile-switcher/item", "settings/components/shared/ui/social-profile-switcher/item");